/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustreasonplaceholder3Inputs */

const zh_adminsubs_adjustreasonplaceholder3 = /** @type {(inputs: Adminsubs_Adjustreasonplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入调整原因`)
};

const en_adminsubs_adjustreasonplaceholder3 = /** @type {(inputs: Adminsubs_Adjustreasonplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter adjustment reason`)
};

const es_adminsubs_adjustreasonplaceholder3 = /** @type {(inputs: Adminsubs_Adjustreasonplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese la razón del ajuste`)
};

/**
* | output |
* | --- |
* | "Enter adjustment reason" |
*
* @param {Adminsubs_Adjustreasonplaceholder3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustreasonplaceholder3 = /** @type {((inputs?: Adminsubs_Adjustreasonplaceholder3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustreasonplaceholder3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustreasonplaceholder3(inputs)
	if (locale === "en") return en_adminsubs_adjustreasonplaceholder3(inputs)
	return es_adminsubs_adjustreasonplaceholder3(inputs)
});
export { adminsubs_adjustreasonplaceholder3 as "adminSubs_adjustReasonPlaceholder" }